(function ($) {
    "use strict";

    console.log("Custom JS loaded successfully!");

    var EMAIL_INPUT_ID = "email_01KRB10D8YXGCQN7Y53638ST0Z";
    var EMAIL_SELECTOR =
        "#" + EMAIL_INPUT_ID + ', .klaviyo-form-YrLZHd input[type="email"]';

    function getLabel($input) {
        return $input
            .closest('[class*="__field-wrapper"]')
            .find(".label-floating");
    }

    function updateLabelState($input) {
        var $label = getLabel($input);
        if (!$label.length) return;

        if ($input.is(":focus") || $input.val().length > 0) {
            $label.addClass("up");
        } else {
            $label.removeClass("up");
        }
    }

    $(document)
        .on("focus", EMAIL_SELECTOR, function () {
            getLabel($(this)).addClass("up");
        })
        .on("blur", EMAIL_SELECTOR, function () {
            updateLabelState($(this));
        })
        .on("input", EMAIL_SELECTOR, function () {
            updateLabelState($(this));
            console.log($(this).val());
        });

    /* Resize Microsoft Clarity / Ads Agent Widget */
    (function () {
        function applyAdAgentStyle() {
            var host = document.querySelector('#ads-agent-host');
            if (host && host.shadowRoot) {
                var rawScale = (typeof window.clarityWidgetScale !== 'undefined' && window.clarityWidgetScale !== null)
                    ? parseFloat(window.clarityWidgetScale)
                    : 75;
                var scaleFactor = Math.max(0.01, Math.min(1.0, rawScale / 100));

                var cssText = `
                    .entrypoint-shadow, [data-testid="entrypoint"] > div {
                        transform: scale(` + scaleFactor + `) !important;
                        transform-origin: bottom center !important;
                    }
                `;

                var existingStyle = host.shadowRoot.querySelector('#ads-agent-custom-style');
                if (!existingStyle) {
                    var style = document.createElement('style');
                    style.id = 'ads-agent-custom-style';
                    style.textContent = cssText;
                    host.shadowRoot.appendChild(style);
                } else {
                    existingStyle.textContent = cssText;
                }
            }
        }

        applyAdAgentStyle();

        var observer = new MutationObserver(function () {
            applyAdAgentStyle();
        });

        if (document.body) {
            observer.observe(document.body, { childList: true, subtree: true });
        } else {
            document.addEventListener('DOMContentLoaded', function () {
                if (document.body) {
                    observer.observe(document.body, { childList: true, subtree: true });
                }
            });
        }
    })();
})(jQuery);
